import React from "react";
import { Link } from "react-router-dom";

const AgentAction = ({ record, onEdit }) => {
    return (
        <div className="dropdown dropdown-action text-end">
            <Link
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
            >
                <i className="material-icons">more_vert</i>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
                <Link
                    className="dropdown-item"
                    data-bs-toggle="modal"
                    data-bs-target="#edit"
                    onClick={() => onEdit(record)}
                >
                    <i className="fa fa-pencil m-r-5" /> Edit
                </Link>

            </div>
        </div>
    );
};

export default AgentAction;
